// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3b76b770","453":"14a57fb2","732":"2e5d765d"}[chunkId] + ".chunk.js";
};